import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, AfterViewInit
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {UserContext} from '../../../../services/user-context';

@Component({
  selector: 'app-publication-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'publication-dialog.template.html',
  animations: [
    trigger('slideIn', [
      state('*', style({ 'overflow-y': 'hidden' })),
      state('void', style({ 'overflow-y': 'hidden' })),
      transition('* => void', [
        style({ height: '*' }),
        animate(250, style({ height: 0 }))
      ]),
      transition('void => *', [
        style({ height: '0' }),
        animate(250, style({ height: '*' }))
      ])
    ])
  ]
})

export class PublicationDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    title: '',
    content: ''
  };
  public publication: any;
  loading = false;

  constructor(private formBuilder: FormBuilder,
              private userContext: UserContext,
              public dialogRef: MatDialogRef<PublicationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    if ( data ) {
      this.publication = Object.assign({}, data);
    }
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({

      author: new FormControl( this.publication ? this.publication.author : this.userContext.user.name, [
        Validators.required,
        Validators.minLength(3)
      ]),
      title: new FormControl( this.publication ? this.publication.title : '', [
        Validators.required,
        Validators.minLength(3)
      ]),
      subtitle: new FormControl( this.publication ? this.publication.subtitle : '', [
        Validators.required,
        Validators.minLength(3)
      ]),
      content: new FormControl( this.publication ? this.publication.content : '', [
        Validators.required
      ]),
      tags: new FormControl( this.publication ? (this.publication.tags || []).join(" ") : '', [
      ]),
      publish: new FormControl( this.publication ? this.publication.publish : true, [
      ]),
      video: new FormControl( this.publication ? this.publication.video : '', [
      ]),
      image: new FormControl( this.publication ? this.publication.image : '', [
      ]),
      syndicate: new FormControl( this.publication ? this.publication.syndicate : false, [
      ]),
      broadcast: new FormControl( this.publication ? this.publication.broadcast : false, [
      ]),
    });
  }

  public save() {
    //this.publication['title'] = this.form.value.title;
    //this.publication['content'] = this.form.value.content;
    this.publication = Object.assign(this.publication || {}, this.form.value)
    if( this.publication.tags ) {
      this.publication.tags = this.publication.tags.trim().toLowerCase().split(/[, ]/);
    }
    this.dialogRef.close(this.publication);
  }

  public cancel() {
    this.dialogRef.close();
  }

}
